import { useAuthStore, UserAvatar } from '@entities/User';
import { Card } from '@shared/ui';

/** Бейджа уровня нет (ТЗ демо 1.12): english_level по умолчанию B2 никто не выбирал, и он ни на что не влияет. */
export function ProfileHeader() {
  const user = useAuthStore((s) => s.user);
  if (!user) return null;
  return (
    <Card padding="none" className="mb-6 p-5 nav:p-8">
      <div className="flex items-center gap-4 nav:gap-5">
        {/* amp-mask / ym-hide-content: имя, email и инициалы не попадают в записи сессий. */}
        <UserAvatar initials={user.initials} size="lg" className="amp-mask ym-hide-content h-[56px] w-[56px] shrink-0 rounded-[18px] text-2xl nav:h-[72px] nav:w-[72px] nav:rounded-[20px] nav:text-3xl" />
        <div className="amp-mask ym-hide-content min-w-0 flex-1">
          <div className="truncate font-serif text-[22px] font-medium tracking-[-0.01em] nav:text-[28px]">{user.name || user.email}</div>
          {user.name && <div className="mt-1 truncate text-[14px] text-muted">{user.email}</div>}
        </div>
      </div>
    </Card>
  );
}
